import React from 'react'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import SimpleCard from './SimpleCard'
import Hidden from '@material-ui/core/Hidden'
import Toolbar from '@material-ui/core/Toolbar'
import { Keep } from '../types/Keep'
import { useKeeps } from '../redux/slices/keepSlice'
import { format } from 'date-fns'
import { useTodos } from '../redux/slices/todoSlice'

const drawerWidth = 310

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    },
    toolbar: theme.mixins.toolbar,
    drawer: {
      [theme.breakpoints.up('sm')]: {
        width: drawerWidth,
        flexShrink: 0,
        padding: theme.spacing(1),
      },
    },
    drawerPaper: {
      width: drawerWidth,
    },
    drawerContainer: {
      overflow: 'auto',
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
  })
)

export default function RightDrawer(): JSX.Element {
  const classes = useStyles()
  const keeps: Keep[] = useKeeps()
  const todos: Keep[] = useTodos()
  const activeKeep = keeps.find((e) => e.isActive)
  const activeTodo = todos.find((e) => e.isActive)

  if (activeKeep) {
    const { task, timestamp } = activeKeep
    const matches = task.match(/\bhttps?:\/\/\S+/gi)
    const date = `${format(new Date(timestamp), 'MMM dd, yyyy')} created`

    return (
      <Hidden smDown implementation="css">
        <nav className={classes.drawer} aria-label="mailbox folders">
          <Toolbar />
          <SimpleCard
            title={'Selected Keep'}
            genre={date}
            desc={task}
            link={matches?.[0]}
          />
        </nav>
      </Hidden>
    )
  }

  if (activeTodo) {
    const { task, timestamp, isImportant } = activeTodo
    const matches = task.match(/\bhttps?:\/\/\S+/gi)

    const help = `${isImportant ? 'important' : ''}`
    const date = `${format(new Date(timestamp), 'MMM dd, yyyy')} created`
    return (
      <Hidden smDown implementation="css">
        <nav className={classes.drawer} aria-label="mailbox folders">
          <Toolbar />
          <SimpleCard
            help={help}
            title={'Selected Todo'}
            genre={date}
            desc={task}
            link={matches?.[0]}
          />
        </nav>
      </Hidden>
    )
  }

  return (
    <Hidden smDown implementation="css">
      <nav className={classes.drawer} aria-label="mailbox folders">
        <Toolbar />
        <SimpleCard
          help={'Suggestion to watch'}
          title={'A Plastic Ocean'}
          genre={'Documentary Films'}
          desc={`When he discovers the world's oceans brimming with plastic waste, a documentary filmmaker investigates the pollution's environmental impacts.`}
          link={'https://www.netflix.com/kr-en/title/80164032'}
        />
      </nav>
    </Hidden>
  )
}
